import { render, staticRenderFns } from "./pageTitle.vue?vue&type=template&id=bc435f28&"
import script from "./pageTitle.vue?vue&type=script&lang=js&"
export * from "./pageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports